export const urls: any = {
    baseUrl: "https://utem.apis.ogr.cl",
    nebuUrl: "https://nebulosa.apis.ogr.cl",
    achievementsUrl: ""
}
